const appConfig = {
    appId: "cashApp-a2e94f16-01ac-4d21-8b9d-aa49b60411a5",
    appName: "Cash",
    site: 'cash-qore',
    icon: "https://nsdstaticasset.blob.core.windows.net/assets/Qore_Brand_Icons/cashQoreAppIcon.png"
};

export default appConfig;
